<template>
 <FontAwesomeIcon :icon="customType" :mask="mask"  :transform="transform" :style="styles" :spin="spin" :pulse="pulse"  :border="border" @click="click"/>
</template>

<script>
export default {
    name: 'faIcon',
    data() {
        return {
           
        };
    },
    created () {
    },
    props: {
        type: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: ''
        },
        size: {
            type: Number,
            default: 16
        },
        proConfig: {
            type:Object,
            default:() => {}
        }
    },
    computed: {
        styles () {
            let style = {};
            style.fontSize = `${this.size}px`;
            if (this.color) {
                style.color = this.color;
            }
            return style;
        },
        customType () {
            if (this.proConfig && this.proConfig.icon) {
                return this.proConfig.icon;
            } else {
                return this.type;
            }
        } ,
        spin() {
            if (this.proConfig && this.proConfig.spin) {
                return this.proConfig.spin;
            } else {
                return false;
            }  
        },
        pulse() {
            if (this.proConfig && this.proConfig.pulse) {
                return this.proConfig.pulse;
            } else {
                return false;
            }  
        },
        pull() {
            if (this.proConfig && this.proConfig.pull) {
                return this.proConfig.pull;
            } else {
                return '';
            }  
        },
        border() {
            if (this.proConfig && this.proConfig.border) {
                return this.proConfig.border;
            } else {
                return false;
            }  
        },
        mask() {
            if (this.proConfig && this.proConfig.mask) {
                return this.proConfig.mask;
            } else {
                return '';
            }  
        },
        transform() {
            if (this.proConfig && this.proConfig.transform) {
                return this.proConfig.transform;
            } else {
                return '';
            }  
        },
        flip() {
            if (this.proConfig && this.proConfig.flip) {
                return this.proConfig.flip;
            } else {
                return '';
            }  
        },
    
    },
    methods:{
        click() {
            this.$emit('click','');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/icon/faicon.vue